@if (i18n.i18nInitialized()) {

  <!-- Sidebar only for branding on error page -->
  <div class="sidebar error">
    <!-- Sidebar Header (Branding) -->
    <div class="sidebar-header" role="banner">
      <div class="branding" aria-label="LOGO">
        <img src="images/branding/gc_brand.svg" alt="GiroCheckout Logo">
        <div class="label" [class.visible]="true">
          <span>Giro</span>
          <span class="bold">Checkout</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Main-Layout -->
  <main class="layout-wrapper error">

    <!-- App Header -->
    <section aria-label="Header" class="app-header" role="banner">
      <div class="header-content">
        <div class="header-item">
          <p-breadcrumb
              [model]="breadcrumbItems">
            <ng-template #item let-item>
              <div class="breadcrumb-link">
                <div class="static-items">
                  <div class="breadcrumb-item font-bold">
                    @if (item?.icon) {
                      <i [ngClass]="item.icon"></i>
                    }
                    @if (item?.label) {
                      <span>{{ item.label }}</span>
                    }
                  </div>
                </div>
              </div>
            </ng-template>
          </p-breadcrumb>
        </div>
      </div>
    </section>

    <!-- Main-Content -->
    <section aria-label="Content" class="app-body" role="main">
      <div class="content-container">
        <main class="main-content">
          <div class="grid">
            <div class="col-12 xl:col-10 xl:col-offset-1">
              <div class="grid">
                <div class="col-12 xl:col-8 lg:col-12">
                  <p-card>
                    <ng-template pTemplate="title">
                      @switch(errorType) {
                        @case ('auth') {
                          <span class="text-error">{{ i18n.i18nLng()['ERRORPAGETITLE'] }}</span>
                        }
                        @case ('permission') {
                          <span class="text-error">{{ i18n.i18nLng()['PERMISSIONPAGETITLE'] }}</span>
                        }
                        @case ('logout') {
                          <span class="text-primary">{{ i18n.i18nLng()['LOGOUTPAGETITLE'] }}</span>
                        }
                        @default {
                          <span class="text-error">{{ i18n.i18nLng()['HTTPDATAERROR'] }}</span>
                        }
                      }
                    </ng-template>
                    @switch(errorType) {
                      @case ('auth') {
                        Bei der Authentifizierung ist ein Fehler aufgetreten.<br>Bitte versuchen Sie es erneut und wenden Sie sich ggf. an den Support.
                      }
                      @case ('permission') {
                      }
                      @case ('logout') {
                      }
                      @default {
                        @switch (errorProvider.errorCode) {
                          @case (ErrorCode.ORGANISATION_DATA) {
                            {{ i18n.i18nLng()['ORGANISATIONDATAERROR'] }}<br>
                          }
                          @case (ErrorCode.USER_DATA) {
                            {{ i18n.i18nLng()['USERDATAERROR'] }}<br>
                          }
                          @case (ErrorCode.PAYMENT_METHODS_CONFIG) {
                            {{ i18n.i18nLng()['USERDATAERROR'] }}<br>
                          }
                          @case (ErrorCode.CUSTOMER_PAYMENT_DATA) {
                            {{ i18n.i18nLng()['PAYMENTDATAERROR'] }}<br>
                          }
                        }
                        <div class="mt-1">
                          {{ i18n.i18nLng()['ERRORDATA'] }}<br>
                          @if (errorProvider?.errorMessage && errorProvider?.errorMessage !== '') {
                            {{ errorProvider.errorMessage }}<br>
                          }
                          @if (errorProvider?.errorDetails && errorProvider?.errorDetails !== '') {
                            {{ errorProvider.errorDetails }}<br>
                          }
                        </div>
                        <div class="mt-1">
                          {{ i18n.i18nLng()['CONTACTSUPPORT'] }}
                        </div>
                      }
                    }
                    <ng-template pTemplate="footer">
                      @switch(errorType) {
                        @case ('logout') {
                          <div class="flex gap-2">
                            <p-button icon="pi pi-sign-in" iconPos="right" [label]="i18n?.i18nLng()['BACKTOLOGIN']" routerLink="/"/>
                          </div>
                        }
                        @default {
                          <div class="flex gap-2">
                            <p-button icon="pi pi-sign-out" iconPos="right" [label]="i18n?.i18nLng()['LOGOUT']" (click)="authService.logoutZBV()"/>
                          </div>
                        }
                      }
                    </ng-template>
                  </p-card>
                </div>
                <div class="col-12 xl:col-4">
                  <sps-support-info gradientStyleClass="sps-background" [showContactSPS]="true"></sps-support-info>
                </div>
              </div>
            </div>
          </div>
        </main>
        <footer aria-label="Footer" class="app-footer" role="contentinfo">
          <div class="footer-branding">
            <img src="images/branding/s-public_logo.svg" alt="S-Public Services Logo">
          </div>
          <div class="footer-content">
            <nav aria-label="Footer Navigation" class="links">
              <!--
              <a tabindex="0" routerLink="/contact" [attr.aria-label]="i18n?.i18nLng()['CONTACTPAGE']">{{ i18n?.i18nLng()['CONTACT'] }}</a>
              <span class="separator">·</span>
              -->
              <a tabindex="0" [href]="imprintUrl" target="_blank"
                 [attr.aria-label]="i18n?.i18nLng()['IMPRINTPAGE']">{{ i18n?.i18nLng()['IMPRINT'] }}</a>
              <span class="separator">·</span>
              <a tabindex="0" [href]="agbUrl" target="_blank" [attr.aria-label]="i18n?.i18nLng()['T&CPAGE']"><abbr
                  [title]="i18n?.i18nLng()['T&CPAGE']">{{ i18n?.i18nLng()['T&C'] }}</abbr></a>
              <span class="separator">·</span>
              <a tabindex="0" [href]="privacyUrl" target="_blank"
                 [attr.aria-label]="i18n?.i18nLng()['PRIVACYPAGE']">{{ i18n?.i18nLng()['PRIVACY'] }}</a>
            </nav>
            <div>
              {{ i18n?.i18nLng()['COPYRIGHT'] }}
            </div>
          </div>
        </footer>
      </div>
    </section>

  </main>
}
